import { Injectable } from '@angular/core';
import { FormGroup, FormBuilder } from "@angular/forms";

@Injectable({
  providedIn: 'root'
})
export class SharedFormService {

  public admissionData = {};

  public previewData = {};

  public signupData = {};

  constructor(private fb: FormBuilder) { }

  /*sharedForm(): FormGroup {
    const admissionData = this.fb.group({
      schools : null,
      StudentName: null,
      DateOfBirth: null,
      PreviousSchool: null,
      PreviousClass: null,
      NewClass: null
    });
    return admissionData;
  }*/
}
